import { appStore } from "src/stores/app.store.ts";

export const useAppStore = () => {
  return appStore;
};
